import AirportAPI from 'api/airport';
import SearchUtils from 'utils/search-utils';
import CMSUtils, {CustomTypes} from 'utils/cms';
import {Page, fetchCity, parseSlug} from 'utils/page-utils';
import {initialState as searchRequestInitialState} from 'store/search-request/search-request-reducer';

const getInitialState = async ({state, cookies, params}) => {
    const pageType = Page.AIRPORT;
    const citySlug = params.city;
    const city = await fetchCity(state, citySlug);
    const code = parseSlug(params.slug);
    const destination = await AirportAPI.getByCode(code).then(res => res.data);
    const {
        data: {timezone},
    } = city;

    const searchRequest = {
        ...searchRequestInitialState,
        pageType,
        ...SearchUtils.createTimeWindowParams(pageType, {}, timezone),
    };

    return {
        ...state,
        city,
        destination,
        searchRequest,
        page: await CMSUtils.getPageData({
            cookies,
            slug: code,
            city,
            customType: CustomTypes.AIRPORT_MIDFUNNEL,
            pageType,
        }),
    };
};

export default getInitialState;
